import { AnalyticsEvents, track } from 'v2/utils/analytics'

const pspDomain = (url: string): string => {
  try {
    return new URL(url).hostname
  } catch {
    return 'invalid'
  }
}

// Navigate the current tab to a PSP 3DS / card-verification URL with telemetry,
// and detect when the navigation never happens (iframe sandbox, an extension,
// or a bad/expired URL) so the caller can surface a manual link.
//
// `window.location.href` is a same-tab top-level navigation (NOT a popup, so
// popup blockers don't apply). If it succeeds the page unloads and the timeout
// is discarded; if we're still here ~2.5s later, the redirect was blocked.
export const startPspRedirect = (url: string): void => {
  const domain = pspDomain(url)
  // sendBeacon so the event survives the immediate page unload on success.
  track(AnalyticsEvents.CARD_3DS_REDIRECT_ATTEMPTED, { domain }, { transport: 'sendBeacon' })

  let left = false
  const markLeft = () => {
    left = true
  }
  window.addEventListener('pagehide', markLeft, { once: true })

  window.location.href = url

  window.setTimeout(() => {
    window.removeEventListener('pagehide', markLeft)
    // Page unloaded / backgrounded → the redirect took; nothing to report.
    if (left || document.visibilityState === 'hidden') return
    track(AnalyticsEvents.CARD_3DS_REDIRECT_BLOCKED, { domain })
  }, 2500)
}

// Fired when the user clicks the manual "verify" link after the auto-redirect
// was blocked. A user-gesture navigation is the most reliable path.
export const openPspManually = (url: string): void => {
  // sendBeacon — we navigate away immediately, same as startPspRedirect.
  track(
    AnalyticsEvents.CARD_3DS_MANUAL_OPENED,
    { domain: pspDomain(url) },
    { transport: 'sendBeacon' },
  )
  window.location.href = url
}
